// api.search post data and result shaping for Search.vue.
// Pure: no network calls, no component state.
import { extend, filter, first, isNull, isString, keys, sortBy } from 'underscore'
import { toQuery } from '@/services/searchFilters.js'

// "12-patchwork" -> "12"; a single digit is returned as is.
export function cleanCategory(category) {
  if (isString(category) && /^\d$/.test(category)) {
    return category
  }

  const values = category.split('-')
  return first(values)
}

// Post data for the "products" tab (Search.load).
export function productsQuery({
  outlet,
  home,
  category,
  filters,
  segment,
  token,
  tag,
  brand,
  metadata = {},
}) {
  const query = {}
  if (outlet) query.outlet = '1'
  if (home) query.home = '1'
  if (category) query.category = cleanCategory(category)

  extend(query, toQuery(filters, "products"))

  if (segment) query.segment = segment.slug
  if (token) query.token = token
  if (tag) query.tag_slug = tag

  // add brand and segment is received
  if (brand) query.brand = brand
  if (segment) query.segment = segment

  // Add metadata if filtered
  if (metadata.level1_metadata) query.level1_metadata = metadata.level1_metadata
  if (metadata.level2_metadata) query.level2_metadata = metadata.level2_metadata
  if (metadata.level3_metadata) query.level3_metadata = metadata.level3_metadata
  if (metadata.designer_metadata)
    query.designer_metadata = metadata.designer_metadata

  return query
}

// Post data for the "new" tabs (Search.loadNewItems).
// telasRestriction: null -> no restriction, true -> "telas", false -> "no-telas"
export function newItemsQuery({
  outlet,
  filters,
  category,
  segment,
  telasRestriction = null,
}) {
  const query = {}
  if (!outlet) query.is_new = '1'
  if (outlet) query.outlet = '1'
  extend(query, toQuery(filters, "new"))
  if (category) query.category = cleanCategory(category)
  if (segment) query.segment = segment.slug

  if (!isNull(telasRestriction)) {
    query.telas_restriction = telasRestriction ? "telas" : "no-telas"
  }

  return query
}

// Sets item.image to the medium src of the lowest-index image. Mutates item.
export function withMainImage(item) {
  const images = sortBy(item.images, (img) => img.index)

  if (images && first(images)) {
    item.image = first(images).srcs.medium
  }

  return item
}

// Drops variant (matrix) items that have no sku in their group.
export function withoutEmptyVariants(items) {
  return filter(items, (item) => {
    if (item.matrix) {
      const skus = keys(item.group)
      if (!skus.length) return false
    }
    return true
  })
}
